import { TUpdateTemplateFavoriteParams, DeleteUserTemplateFavorite } from '@/connection/templates';
import toastTrigger from '@ui/toast/toast-trigger';
import { TemplatesReducerCreator } from '../types';
import { serializeError } from '@/store/utils/serialize-error';
import { EToastTypes } from '@ui/toast/toast.types';

const deleteUserTemplateFavoriteReducer = (create: TemplatesReducerCreator) => {
  return create.asyncThunk(
    async ({ activeChannel, adminId, projectUuid }: TUpdateTemplateFavoriteParams, { rejectWithValue }) => {
      try {
        await DeleteUserTemplateFavorite({ activeChannel, adminId, projectUuid });
        return projectUuid;
      } catch (error) {
        console.error(error);
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.userFavorites) {
          state.userFavorites = state.userFavorites?.filter((f) => f.event_uuid !== action.payload);
        }
      },
      rejected: (_, action) => {
        console.error(action.error);
        toastTrigger('Failed to update favorites', {
          type: EToastTypes.error,
          description: 'Please refresh and try again',
        });
      },
    }
  );
};

export default deleteUserTemplateFavoriteReducer;
